module.exports = __webpack_public_path__ + "static/media/dba-icon.dd1faa14.png";